var _filter, _image, _mask, _clipPath, _use;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoinbasereact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "34px",
    height: "34px",
    viewBox: "0 0 34 34"
  }, props), /*#__PURE__*/React.createElement("defs", null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "alpha",
    filterUnits: "objectBoundingBox",
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    "in": "SourceGraphic",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "image7",
    width: 34,
    height: 34,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACIAAAAiCAYAAAA6RwvCAAAABmJLR0QA/wD/AP+gvaeTAAABJUlEQVRYhe3YsUrDQBjA8f8lEtrBKZrSyVGXgFAqPkQhg+BrONRuPoCYybVPEaQgBXcHcTFDzSK6aIs4FVo9Ip9DW4dbdElvuT/cdMuPu++WUyyTaT+ittWDUYK63IGPgEoKNXLyAvsZn91UbT6+/26JvjmQsjOR0pf1rmQsOm8DKJn2I+pXOVxH1ZzAX3UmzIt4Y3EdthAAgwa14akHo8QeYtVDoqSMvqobzP8WaiWlL3YRizzbgFUOYuYgZg5i5iBmDmLmIGYOYuYgZg5i5iBmHoTaNgJC7SHdZ9sM5OzJg1Zm2wGHmZLp3jb13RwGDTuIozdmzRgA0XlbymS8/m+J41fRfguWr0YF8R3zIkaGF0haVDvAoUbSArk9Z9aMVfB9D/ADKFgD43mu1lkAAAAASUVORK5CYII="
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#alpha)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image7"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    gradientTransform: "matrix(34,0,0,34.089844,0,0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(18.039216%,40%,97.254902%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(7.058824%,29.019608%,85.882353%)",
      stopOpacity: 1
    }
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 34,
    height: 34
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface6",
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 34,
    height: 34,
    style: {
      fill: "url(#linear0)",
      stroke: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(59.215686%,59.215686%,59.215686%)",
      strokeOpacity: 1,
      strokeMiterlimit: 4
    },
    d: "M 64.508042 0.48403 L 318.491958 0.48403 C 353.826172 0.48403 382.51597 29.173828 382.51597 64.508042 L 382.51597 318.491958 C 382.51597 353.826172 353.826172 382.51597 318.491958 382.51597 L 64.508042 382.51597 C 29.173828 382.51597 0.48403 353.826172 0.48403 318.491958 L 0.48403 64.508042 C 0.48403 29.173828 29.173828 0.48403 64.508042 0.48403 Z M 64.508042 0.48403 ",
    transform: "matrix(0.0887728,0,0,0.0887728,0,0)"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#surface6",
    mask: "url(#mask0)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 5.335938 17.007812 C 5.335938 23.523438 10.617188 28.804688 17.132812 28.804688 C 23.648438 28.804688 28.929688 23.523438 28.929688 17.007812 C 28.929688 10.492188 23.648438 5.210938 17.132812 5.210938 C 10.617188 5.210938 5.335938 10.492188 5.335938 17.007812 Z M 14.117188 13.207031 C 13.683594 13.207031 13.332031 13.558594 13.332031 13.992188 L 13.332031 20.019531 C 13.332031 20.457031 13.683594 20.808594 14.117188 20.808594 L 20.148438 20.808594 C 20.582031 20.808594 20.933594 20.457031 20.933594 20.019531 L 20.933594 13.992188 C 20.933594 13.558594 20.582031 13.207031 20.148438 13.207031 Z M 14.117188 13.207031 "
  })));
}
export default SvgCoinbasereact;